import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { EvaluationsState } from '@/store/evaluations/types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const Evaluations: Module<EvaluationsState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default Evaluations;
